<template>
  <div class="wl-table overflow-hidden rounded-2xl bg-default tabular-nums">
    <table class="w-full border-collapse text-sm">
      <thead>
        <tr>
          <th
            v-for="(headerItem, headerIndex) in items.header"
            :key="headerIndex"
            class="max-w-full whitespace-nowrap border-solid border-theme-transparent px-3 py-1.5 text-left font-normal text-muted first:w-full first:max-w-none first:truncate first:whitespace-normal last:border-r-0"
            :class="{
              'border-b': divider === 'grid' || divider === 'horizontal',
              'border-r': divider === 'grid' || divider === 'vertical',
            }"
          >
            <template v-if="$slots.header">
              <slot :header-item="headerItem" name="header" />
            </template>
            <template v-else>
              {{ headerItem }}
            </template>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, rowIndex) in items.rows"
          :key="rowIndex"
          class="border-solid border-theme-transparent last:border-b-0"
          :class="{
            'border-b': divider === 'grid' || divider === 'horizontal',
          }"
        >
          <td
            v-for="(cellContent, cellIndex) in row"
            :key="cellIndex"
            class="truncate border-solid border-theme-transparent px-3 py-1.5 text-end font-medium tabular-nums text-emphasis first:w-full first:text-start first:font-body first:font-normal first:normal-nums first:text-emphasis last:border-r-0"
            :class="{
              'border-r': divider === 'grid' || divider === 'vertical',
            }"
          >
            <template v-if="$slots.row">
              <slot :row-item="cellContent" name="row" />
            </template>
            <template v-else>
              {{ cellContent }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="$slots.banner"
      ref="bannerSlot"
      class="banner inline-block w-full rounded-none border-t border-solid border-theme-transparent px-3 py-2 text-sm leading-5 text-emphasis"
    >
      <slot name="banner" />
    </div>
  </div>
</template>

<script setup lang="ts" generic="T">
import { toRefs } from "vue";
import type { TableProps } from "./types";

const props = withDefaults(defineProps<TableProps<T>>(), {
  divider: "grid",
});

const { items, divider } = toRefs(props);
</script>
